import React from 'react';
import Image from '@moncler/components/experience/EditorialImage';
import '@moncler/scss/components/mini-promo/mini-promo.scss';
const MiniPromo = (props) => {
    const { title, description, link, linkText, src } = props;
    return (React.createElement("div", { className: "mini-promo d-flex" },
        src && (React.createElement("div", { className: "h-100 mini-promo_img_container" },
            ' ',
            React.createElement(Image, Object.assign({}, props, { className: "mini-promo_img" })),
            ' ')),
        React.createElement("div", { className: "mini-promo_info" },
            React.createElement("div", { className: "mini-promo_title" }, title),
            React.createElement("div", { className: "mini-promo_description" }, description),
            React.createElement("a", { href: link, className: "mini-promo_cta" }, linkText))));
};
export default MiniPromo;
